import { render, staticRenderFns } from "./Pushs.vue?vue&type=template&id=f1682f84&"
import script from "./Pushs.vue?vue&type=script&lang=js&"
export * from "./Pushs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports